var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"realize_wrap"},[_vm._m(0),_c('AppointmentCard'),_c('CallMe',{staticStyle:{"margin-top":"0"}}),_c('MobileCallme')],1)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"realize_img"},[_c('div',{staticClass:"img_tit"})])
}]

export { render, staticRenderFns }